<template>
  <div class="integrations-base">
    <div class="mb-6">
      <h4 class="text-semibold">{{ name }}</h4>
      <small>{{ subtitle }}</small>
    </div>
    <div class="integrations-base">
      <div class="text-center py-9" v-if="loading">
        <b-spinner variant="primary" />
      </div>
      <div class="row" v-else>
        <div class="col-lg-4 mb-5" v-for="(opt, i) in options" :key="i">
          <snow-integration-card :integration="opt" :newModal="newModal">
            <template #extra-buttons v-if="opt.name === 'enotas'">
              <router-link
                :to="{ name: 'tools-invoices-details' }"
                class="integration-link fs-12"
              >
                <span>Ir para detalhes</span>
                <i class="ph ph-arrow-square-out" />
              </router-link>
            </template>
          </snow-integration-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      subtitle: "",
      newModal: false,
      loading: false
    };
  },
  computed: {
    options() {
      return [];
    }
  }
};
</script>
